import React from 'react'

export function useContentWidth(ref: React.RefObject<HTMLElement>) {
  const [contentWidth, setContentWidth] = React.useState(200)
  React.useEffect(() => {
    if (ref.current) {
      setContentWidth(ref.current.getBoundingClientRect().width)
    }
  }, [])
  return contentWidth
}
